import "./App.css";
import Body from './components/Body'
import Footer from './components/Footer'

function App() {

  return (
    <div className="App">
      <Body/>
      <Footer/>
    </div>
  );
}

export default App;
